export default "/assets/images/filter-mini.67b320746df98bea.webp";